"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ModalNav;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

/**
 * Representation of a footer in the Dialog.
 * @param {object} props props
 * @param {React.ReactChildren} children react children elements
 * @returns {React.ReactElement} ModalNav
 */
function ModalNav({
  children
}) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-nav"
  }, children);
}

ModalNav.propTypes = {
  /** Child elements */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node])
};